<template>
  <div class="pvManagement" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col >
        <div style="font-size:14px;"> To check the status of or to archive some PV's, please type in some PV names here.</div>
        <el-form ref="textFrom" :model="textFrom" class="queryFromClass">
          <el-form-item label="" prop="text">
            <textarea v-model="textFrom.text" type="textarea" :rows="6"  style="width:6rem;margin-top:0.1rem;"></textarea>
          </el-form-item>
          <el-button align="right" v-on:click="checkStatus()" type="primary">Check Status</el-button>
          <el-upload
            class="uploadClass"
            action="#"
            accept=".txt"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change ='loadTextFile'>
            <el-button align="right"  type="primary">Import</el-button>
          </el-upload>
          <el-button align="right" v-on:click="Archive()" type="primary">Archive</el-button>
          <el-button align="right" v-on:click="ArchiveSpecify()" type="primary">Archive(specify sampling period)</el-button>
          <el-button align="right" v-on:click="Lookup()" type="primary">Lookup</el-button>
          <el-button align="right" v-on:click="Pause()" type="primary">Pause</el-button>
          <el-button align="right" v-on:click="Resume()" type="primary">Resume</el-button>
        </el-form>
        <el-form ref="queryFrom" :model="queryFrom" class="queryFromClass">
          <div align="right" style="width:200px;float:right;">
            <el-button align="right" v-on:click="searchForm('queryFrom')" type="primary">Search</el-button>
            <el-button align="right" v-on:click="resetForm('queryFrom')" type="info">Reset</el-button>
          </div>
          <div align="right" style="width:300px;float:right;">
            <el-form-item label="" prop="keyWords">
              <el-input v-model="queryFrom.keyWords"  placeholder="Search for PV Name"/>
            </el-form-item>
          </div>
        </el-form>
        <el-table v-loading="pieLoading"
          :data="gridData.slice((currentPage-1)*pageSize,currentPage*pageSize)">
          <el-table-column prop="pvName" label="PV Name" width="180" align="center"></el-table-column>
          <el-table-column prop="status" label="Status" width="180" align="center"></el-table-column>
          <el-table-column prop="appliance" label="Appliance" width="150" align="center"></el-table-column>
          <el-table-column prop="connectionState" label="Connected" width="150" align="center"></el-table-column>
          <el-table-column prop="isMonitored" label="Monitored" width="180" align="center"></el-table-column>
          <el-table-column prop="samplingPeriod" label="Sampling period" width="160" align="center"></el-table-column>
          <el-table-column prop="connectionFirstEstablished" label="Last event" width="220" align="center"></el-table-column>
          <el-table-column label="Details" align="center">
            <template slot-scope="scope">
              <el-button  title="Details" type="primary" icon="el-icon-view" circle  @click="handleDetail(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column label="Quick chart" align="center" >
            <template slot-scope="scope">
              <el-button  title="Quick chart" type="primary" icon="el-icon-s-marketing" circle  @click="handleDrawLine(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next"
          :total="gridData.length"
          :page-count="Math.ceil(gridData.length/pageSize)"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
    <pvDetail  v-if="isShowDetail"  :pvDetailInfo="pvDetailInfo" @close="closeDetail" @refreshTable="query(0)"></pvDetail>
    <pvDrawline  v-if="isShowDrawLine"  :pvDetailInfo="pvDetailInfo" @close="closeDrawLine"></pvDrawline>
    <archiveSpecify v-if="isShowArchiveSpecify" :pvName = "pvNameStr" @close="closeArchiveSpecify" @refreshtable="query(1)"></archiveSpecify>

  </div>
</template>

<script>
import axios from 'axios';
import pvDetail from './pvDetail'
import pvDrawline from './pvDrawline'
import archiveSpecify from './archiveSpecify'
    export default {
      name: "pvManagement",
      components:{pvDetail,pvDrawline,archiveSpecify},
      data(){
          return {
            pieLoading:false,
            pageNumber:0,
            pageSize:7,
            currentPage:1,
            gridData: [],
            textFrom:{
              text:'',
            },
            queryFrom:{
              keyWords:''
            },
            pvDetailInfo:{},
            isShowDetail:false,
            isShowDrawLine:false,
            flag:0,  //flag:0或者1,分别代表table查询或者输入框查询
            isShowArchiveSpecify:false,
            pvNameStr:''
          }
      },
      mounted(){
          this.query(0);
      },
      methods:{
        validatePVNames(){
          var patternForPVNames = /^[a-zA-Z0-9:_\-\+\[\]<>;.\/\,\#\{\}]+$/;
          var pvText = this.textFrom.text;
          // Check for value, non-zero length and non-blanks
          if(!pvText || (0 === pvText.length) || (/^\s*$/.test(pvText))) {
            alert("No PVs have been specified for archiving.");
            return false;
          }
          var pvS = pvText.split("\n");
          var message = new String("The following PV names do not match the CA spec");
          var errors = false;
          for(var i = 0; i < pvS.length; i++) {
            if(!pvS[i] || 0 === pvS[i] || (/^\s*$/.test(pvS[i]))) continue;
            if(!patternForPVNames.test(pvS[i].trim())) {
              message = message.concat('\n' + pvS[i]);
              errors = true;
            }
          }
          if(errors) {
            alert(message);
            return false;
          }
          
          return true;
        },
        //表格数据
        query:function (flag) {
          let pv = '';
          if(flag === 0){
            if(this.queryFrom.keyWords === ''){
              pv = '*';
            }else{
              pv = this.queryFrom.keyWords;
            }
          }else{
            if(this.textFrom.text === ''){
              pv = '*';
            }else{
              pv = this.textFrom.text.trim().split(/\s+/).join(",");
            }
          }
          let length = this.textFrom.text.trim().split(/\s+/).length
          if(this.textFrom.text.trim().split(/\s+/).length >100){
              this.$axios.post('/hdars/hdars/mgmt/getPVStatus',{
                pv:pv,
                reporttype:"short"}).then((response) => {
                this.gridData = response.data
              })
          }else{
              this.$axios({ 
                method:'get',
                url:'/hdars/hdars/mgmt/getPVStatus?pv=' + pv + '&reporttype=short'
              }).then((response) => {
                if(response.data.code == -1){//没有登录
                  this.$message(response.data.data);
                  this.$root.$children[0].dialogVisible = true
                  return;
                }else if(response.data.code == -2){
                  this.$message(response.data.data);
                  return
                }else{
                  this.gridData = response.data
                }
            })
          }
        },
        handleDetail(index,row){
          this.pvDetailInfo = row;
          this.isShowDetail = true;
        },
        handleDrawLine(index,row){
          this.pvDetailInfo = row;
          this.isShowDrawLine = true;
        },
        currentPageChange:function(val){
          this.currentPage = val;
        },
        // 查询表格
        searchForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.query(0);
            } else {
              console.log('error search!!');
              return false;
            }
          });
        },
         // 重置查询条件
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.textFrom.text = '';
          this.query(0);
        },
        //checkStatus事件
        checkStatus(){
          this.query(1);
        },
        //Archive事件
        Archive(){
          if(this.validatePVNames()){
            this.$axios({ 
              method:'get',
              url:'/hdars/hdars/mgmt/archivePV?pv=' + this.textFrom.text.trim().split(/\s+/).join(",")
            }).then(() => {
              this.query(1);
            })
          }
        },
        //ArchiveSpecify事件
        ArchiveSpecify(){
          if(this.validatePVNames()){
            this.pvNameStr = this.textFrom.text.trim().split(/\s+/).join(",");
            this.isShowArchiveSpecify = true;
          }
        },
        //Lookup事件
        Lookup(){
          let str = '';
          if(this.textFrom.text === ''){
            this.$message("No PVs have been specified.");
          }else if(this.textFrom.text === '*'){
            this.gridData.forEach((item)=>{
              str += item.pvName + '\n';
            })
            this.textFrom.text = str;
            this.query(1);
          }else{
            this.query(1);
          }
        },
        //Pause事件
        Pause(){
          if(this.validatePVNames()){
            this.$axios({ 
              method:'get',
              url:'/hdars/hdars/mgmt/pauseArchivingPV?pv=' + this.textFrom.text.trim().split(/\s+/).join(",")
            }).then(() => {
                this.$message('Operation successful');
                this.query();
              }).catch( ()=>{this.$message('Operation failed');})
          }
        },
        //Resume事件
        Resume(){
          if(this.validatePVNames()){
            this.$axios({ 
              method:'get',
              url:'/hdars/hdars/mgmt/resumeArchivingPV?pv=' + this.textFrom.text.trim().split(/\s+/).join(",")
            }).then(() => {
                this.$message('Operation successful');
                this.query();
              }).catch( ()=>{this.$message('Operation failed');})
          }
        },
        //文件上传事件
        beforeUpload(file){
          const type = file.type === 'text/plain';
          if(!type){
            this.$message.error('Upload file can only be in txt format');
          }
          return false;
        },
        //关闭详情弹出框
        closeDetail(){
          this.isShowDetail = false
        },
        //关闭表格弹出框
        closeDrawLine(){
          this.isShowDrawLine = false
        },
        closeArchiveSpecify(){
          this.isShowArchiveSpecify = false
        },
        loadTextFile(e){
          const file = e.raw;
          const reader = new FileReader();
          reader.onload = e => this.$emit("load",this.displayTxt(e.target.result));
          reader.readAsText(file);
        },
        displayTxt(item){
          this.textFrom.text = item;
        }
      }
    }

</script>

<style scope>
 .pvManagement .el-form-item {margin-bottom: 0px;}
 .pvManagement .uploadClass{display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/pvManagement/pvManagement.vue